module.exports = __webpack_public_path__ + "img/smartRamp.fed0be87.svg";